/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../model/shared/device_profile_type';
import '../model/shared/device_profile_template_type';
import './status';
import '../model/device_profile';
import '../model/shared/device_profile';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "GetDefaultDeviceProfileV2Request": {
                        "fields": {
                          "deviceProfileType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "templateType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileTemplateType",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetDefaultDeviceProfileV2Response": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "profile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileV2",
                            "id": 2,
                            "rule": "optional"
                          },
                          "deviceProfile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.GetDefaultDeviceProfileV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.GetDefaultDeviceProfileV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetDefaultDeviceProfileV2Request @ squareup/devicesettings/profiles/v2/message/get_default_device_profile.proto at 15:1
 */
export const GetDefaultDeviceProfileV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.GetDefaultDeviceProfileV2Request');
fixType(GetDefaultDeviceProfileV2Request);
Builder.createAndAttachToType(GetDefaultDeviceProfileV2Request);
/**
 * SOURCE GetDefaultDeviceProfileV2Response @ squareup/devicesettings/profiles/v2/message/get_default_device_profile.proto at 20:1
 */
export const GetDefaultDeviceProfileV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.GetDefaultDeviceProfileV2Response');
fixType(GetDefaultDeviceProfileV2Response);
Builder.createAndAttachToType(GetDefaultDeviceProfileV2Response);